import { type FC, type ReactNode, useEffect, useRef } from "react";
import { Blac } from "blac-next";
import TourGuideCubit from "./TourGuideCubit";
import { toAnchorVar } from "./constants";

const WRAPPER_STYLE = { display: "contents" } as const;

const TourGuideAnchor: FC<{ name: string; children: ReactNode }> = ({
  name,
  children
}) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = wrapperRef.current?.firstElementChild as HTMLElement | null;
    if (el) {
      (el.style as unknown as Record<string, string>).anchorName =
        toAnchorVar(name);
      el.dataset.tourAnchor = name;
    }

    const cubit = Blac.getBloc(TourGuideCubit);
    const borderRadius = el ? getComputedStyle(el).borderRadius : undefined;
    cubit.registerAnchor(name, { borderRadius });

    return () => {
      if (el) {
        (el.style as unknown as Record<string, string>).anchorName = "";
        delete el.dataset.tourAnchor;
      }
      cubit.unregisterAnchor(name);
    };
  }, [name]);

  return (
    <span ref={wrapperRef} style={WRAPPER_STYLE}>
      {children}
    </span>
  );
};

export default TourGuideAnchor;
